export const HANDOUT_FORMAT_CATEGORY = 'Handouts';

export const SPECIES_OPTIONS = ['Canine', 'Feline', 'Equine', 'Small Animals', 'Farm Animals', 'Exotic Animals'];

export const CONDITION_CATEGORY_OPTIONS = [
    'Behaviour',
    'Dentistry',
    'Dermatology',
    'Emergency',
    'General anatomy',
    'General principles',
    'Internal medicine',
    'Neurology',
    'Ophthalmology',
    'Orthopaedics',
    'Parasites',
    'Reproduction',
    'Surgery',
];

const normalize = (value) => (value || '').toString().trim().toLowerCase();

export const deepContainsCategory = (value, target) => {
    const targetNormalized = normalize(target);
    if (!targetNormalized) return false;

    if (Array.isArray(value)) return value.some((entry) => deepContainsCategory(entry, targetNormalized));
    if (value && typeof value === 'object') {
        return Object.entries(value).some(
            ([key, nestedValue]) =>
                normalize(key) === targetNormalized || deepContainsCategory(nestedValue, targetNormalized),
        );
    }
    if (typeof value === 'string') return normalize(value) === targetNormalized;
    return false;
};

export const getSelectedPlatformCategories = (categories = {}) => ({
    species: SPECIES_OPTIONS.filter((label) => deepContainsCategory(categories, label)),
    conditionCategories: CONDITION_CATEGORY_OPTIONS.filter((label) => deepContainsCategory(categories, label)),
});

export const buildPlatformCategories = ({ species = [], conditionCategories = [] }) => {
    const categories = {
        [HANDOUT_FORMAT_CATEGORY]: [],
    };

    if (species.length > 0) {
        categories.Animal = species.reduce((accumulator, label) => {
            accumulator[label] = [];
            return accumulator;
        }, {});
    }

    conditionCategories.forEach((label) => {
        categories[label] = [];
    });

    return categories;
};

export const getPlatformCategoryFilterGroups = () => [
    { key: 'species', title: 'Species', options: SPECIES_OPTIONS },
    { key: 'conditionCategories', title: 'Condition Categories', options: CONDITION_CATEGORY_OPTIONS },
];
